/* setupProduct.component.js */

import setupProductController from "./setupProduct.controller";

/**
 * @desc component for creating and editing a new product in connection settings.
 * @example <setup-product></setup-product>
 */

const setupProduct = {
    bindings: {
        product: '<',
        saveStep: '<',
        modules: '<',
        updateHiddenSteps: '<',
        isCreate: '<'
    },
    controller: setupProductController,
    controllerAs: 'spvm',
    templateUrl: '/App/Components/Connections/productSetup/setupProduct.tmpl.html'
};

export default setupProduct;